export default __webpack_public_path__ + "static/media/filterIcon.b886071a.svg";